import React, { useContext } from 'react';

type AuthContextType = {};

export const AuthContext = React.createContext<AuthContextType | undefined | null>(undefined);

export function useAuth() {
  return useContext(AuthContext);
}
